import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button, message } from "antd";
import Page404 from "app/not-found";
import { useSelector } from "react-redux";

const API_URL = process.env.REACT_APP_API_URL;
const BASE_URL = "https://ahuncycle.com";

const PageEnvoyerInfolettre = () => {
  const { user } = useSelector((state) => state.user);

  const [infolettres, setInfolettres] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [loading, setLoading] = useState(false);
  const [messageText, setMessageText] = useState(""); 
  const [sendResult, setSendResult] = useState(null); // <- Résultat de l'envoi

  useEffect(() => {
    const fetchInfolettres = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/infolettre`);
        setInfolettres(res.data);
      } catch (err) {
        console.error("Erreur récupération infolettres:", err);
        message.error("Impossible de charger les infolettres");
      }
    };
    fetchInfolettres();
  }, []);

  const selectedInfolettre = infolettres.find((i) => i._id === selectedId);

  useEffect(() => {
    if (selectedInfolettre) {
      setMessageText(
        `Bonjour,\n\nNous sommes heureux de partager avec vous la dernière infolettre de Ahuncycle :\n\n${BASE_URL}${selectedInfolettre.href}\n\nVous y trouverez toutes les nouveautés et informations importantes.\n\nBonne lecture !`
      );
    } else {
      setMessageText("");
      setSendResult(null);
    }
  }, [selectedInfolettre]);

  const handleEnvoyer = async () => {
    if (!selectedInfolettre) {
      message.error("Veuillez sélectionner une infolettre");
      return;
    }

    setLoading(true);
    setSendResult(null);

    try {
      const res = await axios.post(`${API_URL}/api/infolettre/envoyer`, {
        sujet: `Nouvelle infolettre : ${selectedInfolettre.titre}`,
        message: messageText,
      });

      // Mettre à jour le résultat pour affichage
      setSendResult(res.data);

      message.success("Infolettre envoyée. Voir les détails ci-dessous.");
    } catch (err) {
      console.error("Erreur envoi infolettre:", err);
      message.error("Erreur lors de l’envoi de l’infolettre");
    } finally {
      setLoading(false);
    }
  };

  if (!user) return <Page404 />;

  return (
    <div className="max-w-2xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6 text-center">
        Envoyer une infolettre
      </h1>

      <div className="flex flex-col gap-4">
        <div className="flex flex-col">
          <label className="font-bold mb-1">Sélectionner l’infolettre</label>
          <select
            value={selectedId}
            onChange={(e) => setSelectedId(e.target.value)}
            className="border rounded px-3 py-2"
          >
            <option value="">— Choisir —</option>
            {infolettres.map((info) => (
              <option key={info._id} value={info._id}>
                {info.titre}
              </option>
            ))}
          </select>
        </div>

        {selectedInfolettre && (
          <>
            <div className="bg-gray-50 border rounded p-3 text-sm">
              <p className="font-semibold">Lien de l’infolettre :</p>
              <a
                href={`${BASE_URL}${selectedInfolettre.href}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline break-all"
              >
                {BASE_URL}
                {selectedInfolettre.href}
              </a>
            </div>

            <div className="bg-gray-100 border rounded p-4 mt-2 flex flex-col gap-3">
              <div className="flex flex-col">
                <label className="font-semibold mb-1">Sujet :</label>
                <input
                  type="text"
                  value={`Nouvelle infolettre : ${selectedInfolettre.titre}`}
                  readOnly
                  className="border rounded px-3 py-2"
                />
              </div>

              <div className="flex flex-col">
                <label className="font-semibold mb-1">Message :</label>
                <textarea
                  value={messageText}
                  onChange={(e) => setMessageText(e.target.value)}
                  rows={6}
                  className="border rounded px-3 py-2 resize-none"
                />
              </div>
            </div>

            <Button
              type="primary"
              onClick={handleEnvoyer}
              loading={loading}
              disabled={!selectedInfolettre}
            >
              Envoyer l’infolettre
            </Button>

            {/* === Affichage des résultats === */}
            {sendResult && (
              <div className="bg-yellow-50 border border-yellow-300 rounded p-4 mt-4 text-sm">
                <p><strong>{sendResult.message}</strong></p>
                {sendResult.failedAbonnes && sendResult.failedAbonnes.length > 0 && (
                  <>
                    <p className="mt-2 font-semibold">Abonnés échoués :</p>
                    <ul className="list-disc list-inside">
                      {sendResult.failedAbonnes.map((ab, idx) => (
                        <li key={idx}>
                          {ab.nom} &lt;{ab.email}&gt; — {ab.reason}
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PageEnvoyerInfolettre;
